import React from 'react';
import { motion } from 'framer-motion';
import { Product } from './FightCardProduct';
const WALKOUT_PRODUCTS: Product[] = [{
  id: 'w1',
  name: 'THE CONTENDER ROBE',
  price: 120,
  category: 'WALKOUT',
  image: 'https://images.unsplash.com/photo-1517438476312-10d79c077509?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 'w2',
  name: 'LEGACY JERSEY',
  price: 85,
  category: 'WALKOUT',
  image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 'w3',
  name: 'VICTORY TRACKSUIT',
  price: 160,
  category: 'WALKOUT',
  image: 'https://images.unsplash.com/photo-1556906781-9a412961c28c?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 'w4',
  name: 'MAIN EVENT TEE',
  price: 55,
  category: 'WALKOUT',
  image: 'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?q=80&w=1000&auto=format&fit=crop'
}];
interface WalkoutSectionProps {
  onAddToCart: (product: Product) => void;
}
export function WalkoutSection({
  onAddToCart
}: WalkoutSectionProps) {
  return <section className="py-32 bg-fight-black relative overflow-hidden" data-id="element-184">
      <div className="absolute inset-0 bg-cage-grid opacity-8 pointer-events-none" data-id="element-185" />
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-fight-black to-transparent z-10" data-id="element-186" />
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-fight-black to-transparent z-10" data-id="element-187" />

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-20" data-id="element-188">
        <div className="text-center mb-20" data-id="element-189">
          <motion.h2 initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} className="text-6xl md:text-8xl font-bebas mb-4 glitch-text" style={{
          color: '#e0e0e0'
        }} data-text="WALKOUT MODE" data-id="element-190">
            WALKOUT MODE
          </motion.h2>
          <p className="font-barlow text-xl tracking-[0.3em] uppercase" style={{
          color: 'rgba(153,27,27,0.8)',
          textShadow: '0 0 20px rgba(153,27,27,0.3)'
        }} data-id="element-191">
            Entering The Octagon
          </p>
        </div>

        <div className="space-y-32" data-id="element-192">
          {WALKOUT_PRODUCTS.map((product, index) => <motion.div key={product.id} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -100 : 100
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} viewport={{
          margin: '-100px'
        }} className={`flex flex-col md:flex-row items-center gap-12 ${index % 2 === 1 ? 'md:flex-row-reverse' : ''}`} data-id="element-193">
              {/* Image Side */}
              <div className="w-full md:w-1/2 relative group" data-id="element-194">
                {/* Soft red spotlight behind image */}
                <div className="absolute inset-0 rounded-sm opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none" style={{
              background: 'radial-gradient(ellipse at 50% 50%, rgba(153,27,27,0.15) 0%, transparent 70%)',
              filter: 'blur(20px)',
              transform: 'scale(1.2)'
            }} data-id="element-195" />
                <div className="relative aspect-[4/5] overflow-hidden transition-transform duration-500 group-hover:scale-[1.02]" style={{
              background: 'rgba(255,255,255,0.02)',
              backdropFilter: 'blur(4px)',
              border: '1px solid rgba(255,255,255,0.07)'
            }} data-id="element-196">
                  <img src={product.image} alt={product.name} className="w-full h-full object-cover opacity-70 group-hover:opacity-85 transition-opacity duration-500" data-id="element-197" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" data-id="element-198" />
                  {/* Inner glow on hover */}
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
                background: 'radial-gradient(ellipse at 50% 100%, rgba(245,230,20,0.05) 0%, transparent 60%)'
              }} data-id="element-199" />
                </div>
              </div>

              {/* Content Side */}
              <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-200">
                <h3 className="text-5xl md:text-7xl font-bebas mb-4" style={{
              color: '#e0e0e0'
            }} data-id="element-201">
                  {product.name}
                </h3>
                <p className="font-barlow text-lg mb-8 max-w-md mx-auto md:mx-0" style={{
              color: '#555'
            }} data-id="element-202">
                  Official walkout gear worn by the elite. Engineered for the
                  moments before the cage door closes.
                </p>
                <div className="flex items-center justify-center md:justify-start gap-6" data-id="element-203">
                  <span className="text-3xl font-bebas yellow-glow-text" data-id="element-204">
                    ${product.price}
                  </span>
                  <button onClick={() => onAddToCart(product)} className="px-8 py-3 font-bebas text-xl transition-all duration-300" style={{
                background: 'rgba(255,255,255,0.04)',
                backdropFilter: 'blur(8px)',
                border: '1px solid rgba(255,255,255,0.12)',
                color: '#e0e0e0'
              }} onMouseEnter={e => {
                ;
                (e.currentTarget as HTMLButtonElement).style.background = 'rgba(255,255,255,0.1)';
                (e.currentTarget as HTMLButtonElement).style.borderColor = 'rgba(255,255,255,0.25)';
              }} onMouseLeave={e => {
                ;
                (e.currentTarget as HTMLButtonElement).style.background = 'rgba(255,255,255,0.04)';
                (e.currentTarget as HTMLButtonElement).style.borderColor = 'rgba(255,255,255,0.12)';
              }} data-id="element-205">
                    ADD TO CART
                  </button>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}